import { Card, Muted, Table, TableBox } from '@widgets/ksp-workspace/parts';
import type { KspRdReadiness } from '@entities/ksp/types';
import { STATE_LABEL, setText } from '../types';

export interface RdReadinessCardProps {
  readiness: KspRdReadiness[];
  activityLabel: Map<string, string>;
  timezone: string;
}

export function RdReadinessCard({ readiness, activityLabel, timezone }: RdReadinessCardProps) {
  return (
    <Card>
      <h3>Готовность РД по работам (для следующего расчёта)</h3>
      <TableBox>
        <Table>
          <thead>
            <tr>
              <th>Работа</th>
              <th>Готовность</th>
              <th>Не раньше</th>
              <th>Основание</th>
            </tr>
          </thead>
          <tbody>
            {readiness.map((r) => (
              <tr key={r.activity_id}>
                <td>{activityLabel.get(r.activity_id) ?? r.activity_id}</td>
                <td>{STATE_LABEL[r.state]}</td>
                <td>{r.ready_at ? new Date(r.ready_at).toLocaleString('ru-RU', { timeZone: timezone }) : '—'}</td>
                <td>{r.sets.map(setText).join('; ')}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableBox>
      {readiness.length === 0 && (
        <Muted>Подтверждённых связей работ с комплектами РД нет — расчёт идёт без ограничения по РД.</Muted>
      )}
    </Card>
  );
}
